import assetColors from '../../assets/assetColors';
import partsCategories from '../partsCategories';
import SelectedColors from '../types/SelectedColors';

export default (): SelectedColors => {
  const randomSelectedColors: SelectedColors = {};

  partsCategories.forEach((partsCategory) => {
    const assetColorsForCategory = assetColors[partsCategory.name];
    if (assetColorsForCategory) {
      randomSelectedColors[partsCategory.name] =
        assetColorsForCategory[
          Math.floor(Math.random() * assetColorsForCategory.length)
        ];
    }
  });

  return randomSelectedColors;
};
